import styled from "styled-components";

export const ExpContainer = styled.div`
    margin-top: 1rem;
    color: var(--pallet-4);
`
